<template>
  <table>
    <tr
      class="info-item"
      v-for="(item, key, counter) in deviceInfo"
      :key="key"
      @click="test"
      :tabindex="counter"
    >
      <td class="key">{{ key }}</td>
      <td>{{ JSON.stringify(item) }}</td>
    </tr>
  </table>
</template>
<script>
export default {
  data() {
    return {
      deviceInfo: {},
    };
  },
  methods: {
    test(event) {
      event.currentTarget.focus();
      console.log(event.currentTarget);
    },
    hanleRemote(event) {
      console.log('HANDLE REMOTE', event);
    },
    // eventHandler(key) {
    //   switch (key) {
    //     case KEYS.BACK:
    //     case KEYS.ENTER:
    //       router.go(-1);
    //       break;
    //   }
    // },
  },
  computed: {},
  watch: {},
  mounted() {
    /* eslint-disable */
    // console.log('here', navigator, window.navigator);
    if (!navigator) return;
    this.deviceInfo = {};
    console.log(typeof navigator, Object.keys(navigator).length);
    this.deviceInfo.width = window.innerWidth;
    this.deviceInfo.height = window.innerHeight;
    for (const prop in navigator) {
      // console.log(prop, navigator[prop]);
      if (navigator[prop]) {
        if (typeof navigator[prop] === 'function') continue;
        if (typeof navigator[prop] === 'object') continue;
        // if (typeof navigator[prop] === 'object') {
        //   if (!Object.keys(navigator[prop]).length) {
        //     continue;
        //   }
        // }
        this.deviceInfo[prop] = navigator[prop];
      }
    }

    // console.log(this.deviceInfo);
  },
};
</script>

<style scoped>
.key {
  font-weight: bold;
  padding-right: 1rem;
}
h2 {
  margin: 0 1rem 1rem;
}
table {
  border-collapse: collapse;
  margin: 0 1rem;
}
td {
  padding: 0.5rem 0;
}
.info-item {
  border-bottom: 1px solid black;
}
.video-test {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoDashboard.vue